<script>
    import {onMount} from 'svelte'
    import Link from '@src/router/Link.svelte'    
    import {locale,language ,getStationStatus} from '@src/languages'
    import PermissionCheck from '@src/components/PermissionCheck.svelte'
    
    export let station ;
    
    onMount(()=>{
        
    })

    function goToMap(s){
        const handle = () => {
            let param = s.latitude + "," + s.longitude ;                
            let url = "http://maps.google.com/maps?q=" + param + "&ll=" + param + "&z=20";
            window.open(url);
        }
        return handle
    }

    const statusColors = {
           'ACTIVE' : 'border-green-400',          
           'INACTIVE' : 'border-red-400',          
           'UNDERCONSTRUCTION': 'border-yellow-400',
           'RESERVED': 'bg-gray',
           'MAINTENANCE':  'border-orange-400'         
    }

</script>
<div class="mb-4 p-2  border-{$language == 'ar'?'r':'l'}-8 {statusColors[station.status]} shadow-md">
    <header class="font-bold border-b-2 p-1 mb-1 flex flex-row justify-between">
        <Link to={"detail"} {...$$props} params={{station_id:station.id,station}} class="w-full" >                                
            <span class="px-4 text-green-600">{$language.label_station_no} : {station.no}</span>
            {#if station.no_old}                                   
            <span class="text-red-400 px-10">{$language.label_before} : {station.no_old}</span>                
            {/if}
        </Link>
        <PermissionCheck permissions={['STATION_LOCATION.VIEW']}>
            <button class="text-green-600" on:click={goToMap(station)}>
                <svg viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg" width="21" height="21"><path d="M6 6.496a1.5 1.5 0 013 0 1.5 1.5 0 01-3 0z" fill="currentColor"></path><path fill-rule="evenodd" clip-rule="evenodd" d="M1 6.496A6.499 6.499 0 017.5 0C11.089 0 14 2.909 14 6.496c0 2.674-1.338 4.793-2.772 6.225a10.865 10.865 0 01-2.115 1.654c-.322.19-.623.34-.885.442-.247.098-.506.174-.728.174-.222 0-.481-.076-.728-.174a6.453 6.453 0 01-.885-.442 10.868 10.868 0 01-2.115-1.654C2.338 11.289 1 9.17 1 6.496zm6.5-2.499a2.5 2.5 0 00-2.5 2.5 2.5 2.5 0 005 0 2.5 2.5 0 00-2.5-2.5z" fill="currentColor"></path></svg>
            </button>

        </PermissionCheck>
    </header>
    <div class="grid grid-cols-4 gap-4 p-2">
        <span class="col-span-2">{$language.label_governorate} : {$locale == 'ar'?station.area.governorate.name:station.area.governorate.name_en}</span>            
        <span class="col-span-2">{$language.label_area} : {$locale == 'ar' ? station.area.name:station.area.name_en }</span>            
        <span class="col-span-2">{$language.label_station_model} : {station.model || '-'} </span>
        <span class="col-span-4">{$language.label_station_transNo} : {station.transformers_no || '-'} </span>
        <span class="col-span-2">{$language.label_station_address} : {station.address || '-'} </span>
        <span class="col-span-2">{$language.label_station_addressNo} : {station.address_no || '-'} </span>
        <span class="col-span-4">{$language.label_station_status } : { getStationStatus(station.status)}</span>
    </div>                            
</div>